// extracted by css-extract-rspack-plugin
export default {"headerName":"headerName-N4iLX6","tabButton":"tabButton-aoAV8J"};